module.exports = {
  handleFlipbook() {
    const itemLevel = document.body.classList.contains('single-page');
    const flipbook = document.body.classList.contains('uberflip');

    if (itemLevel && flipbook) {
      const title = document.querySelector('.entry-wrapper h1');
      const metaData = document.querySelector('.entry-wrapper .meta-wrapper');

      const itemContainer = document.querySelector('.level-three');
      const flipbookWrapper = document.querySelector('.single-embed-wrapper');

      itemContainer.insertBefore(title, flipbookWrapper);
      itemContainer.insertBefore(metaData, flipbookWrapper);
    }
  },
};


// WEBPACK FOOTER //
// ./scriptPartials/handleFlipbook.js